"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = "#overlay {\n  background: rgba(22, 22, 22, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n";
  const fileName = "Overlay_Overlay";
  const element = document.querySelector("style[data-sass-component='Overlay_Overlay']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
/**
 * Alternative to our Modal. Our Modal has required elements, and it is very restricted.
 * Alternative to Carbon's Modal or ModalWrapper. They render a button for modal opening, and they force to have
 * buttons at the edge.
 */
const Overlay = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'overlay'
  }, props.children);
};
var _default = exports.default = Overlay;